import {countryCodeToName, languageCodeToName} from "@/utils"

// A stored propagation preset: country and/or language codes. Either may be
// empty, never both (the backend rejects that).
export type FilterPreset = {country?: string; language?: string}

// Compact form for chips: "FR · fr", "FR" or "fr".
export const presetShortLabel = (preset: FilterPreset): string =>
    [
        (preset.country || "").toUpperCase(),
        (preset.language || "").toLowerCase(),
    ].filter(Boolean).join(" · ")

// Readable form for tooltips: "France · French".
export const presetLongLabel = (preset: FilterPreset): string =>
    [
        preset.country ? countryCodeToName(preset.country) : "",
        preset.language ? languageCodeToName(preset.language) : "",
    ].filter(Boolean).join(" · ")

// Indexes the provider's synthesis by brand id and by range id so cards can
// look their own entry up in O(1). Ranges listed are overrides only.
export const indexPropagatedFilters = (synthesis: {brands: any[]; ranges: any[]} | null) => {
    const byBrand: Record<string, FilterPreset[]> = {}
    const byRange: Record<string, FilterPreset[]> = {}
    if (!synthesis) return {byBrand, byRange}
    for (const b of synthesis.brands ?? []) {
        if (b?.brand_id && Array.isArray(b.presets) && b.presets.length > 0) byBrand[b.brand_id] = b.presets
    }
    for (const r of synthesis.ranges ?? []) {
        if (r?.range_id && Array.isArray(r.presets) && r.presets.length > 0) byRange[r.range_id] = r.presets
    }
    return {byBrand, byRange}
}
